export const LOADING_SCREEN_IMAGE = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/contact-sales/Contact_sales_Loader_no_bg.gif";
export const LOADING_SCREEN_IMAGE_ALT = "Loading...";
